<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M19.707 4.293a1 1 0 010 1.414L7.414 18H15a1 1 0 110 2H5a1 1 0 01-1-1V9a1 1 0 112 0v7.586L18.293 4.293a1 1 0 011.414 0z"/></svg>